// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"101":"bcd5296c","130":"420ac316","483":"9075b129","785":"b61cb9b7","787":"09c7dba2","998":"43faa3f0"}[chunkId] + ".chunk.js";
};